import { formatMoney } from "@/shared/lib/currency";
import { fromIso8601Date, toLocaleTextAsDate } from "@/shared/lib/datetime";
import { MobileDeliveryProposalFormTable } from "@/widgets/delivery-proposal-form-table/mobile-delivery-proposal-form-table";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DeliveryProposalFormLayout } from "../../../../../widgets/delivery-proposal-form-layout";
import { DeliveryProposalFormTable } from "../../../../../widgets/delivery-proposal-form-table";
import type { AdminDeliveryProposalDetailPageProps } from "../../../model";

export const PaymentForm = (props: {
  draftOfferCargo: AdminDeliveryProposalDetailPageProps["draftOfferCargo"];
  previewValues: NonNullable<
    AdminDeliveryProposalDetailPageProps["previewValues"]
  >;
}) => {
  const { t } = useTranslation();

  const { draftOfferCargo, previewValues } = props;

  const shippingFeeCells = [
    formatMoney(draftOfferCargo.data?.shippingFee),
    formatMoney(previewValues.shippingFee),
  ];

  const highwayFeeCells = [
    draftOfferCargo.data?.highwayFee && draftOfferCargo.data.highwayFee > 0
      ? "あり"
      : "なし",
    null,
  ];

  const highwaySectionCells = [draftOfferCargo.data?.highwaySection, null];

  const fuelSurchargeCells = [
    formatMoney(draftOfferCargo.data?.fuelSurcharge),
    null,
  ];

  const cargoHandlingFeeCells = [
    formatMoney(draftOfferCargo.data?.cargoHandlingFee),
    null,
  ];

  const othersFeeCells = [formatMoney(draftOfferCargo.data?.othersFee), null];

  const adjustmentFeeCells = [
    formatMoney(draftOfferCargo.data?.adjustmentFee),
    null,
  ];

  const paymentDateCells = [
    draftOfferCargo.data?.paymentDate
      ? toLocaleTextAsDate(fromIso8601Date(draftOfferCargo.data?.paymentDate))
      : null,
    null,
  ];

  const basicFeeMemoCells = [draftOfferCargo.data?.basicFeeMemo, null];

  return (
    <DeliveryProposalFormLayout title={"運賃"} isLoading={false}>
      <div>
        {/* PC用のフォーム */}
        <Box display={{ xs: "none", sm: "block" }}>
          <DeliveryProposalFormTable
            headers={["荷物", "提案"]}
            rows={[
              {
                title: t("offerCargo.shippingFee"),
                cells: shippingFeeCells,
              },
              {
                title: t("offerCargo.highwayFee"),
                cells: highwayFeeCells,
              },
              {
                title: t("offerCargo.highwaySection"),
                cells: highwaySectionCells,
              },
              {
                title: t("offerCargo.fuelSurcharge"),
                cells: fuelSurchargeCells,
              },
              {
                title: t("offerCargo.cargoHandlingFee"),
                cells: cargoHandlingFeeCells,
              },
              {
                title: t("offerCargo.othersFee"),
                cells: othersFeeCells,
              },
              {
                title: t("offerCargo.adjustmentFee"),
                cells: adjustmentFeeCells,
              },
              {
                title: t("offerCargo.paymentDate"),
                cells: paymentDateCells,
              },
              {
                title: t("offerCargo.basicFeeMemo"),
                cells: basicFeeMemoCells,
              },
            ]}
          />
        </Box>

        {/* モバイル用のフォーム */}
        <Box display={{ xs: "block", sm: "none" }}>
          <MobileDeliveryProposalFormTable
            items={[
              {
                label: t("offerCargo.shippingFee"),
                cargo: shippingFeeCells[0],
                proposal: shippingFeeCells[1],
              },
              {
                label: t("offerCargo.highwayFee"),
                cargo: highwayFeeCells[0],
                proposal: highwayFeeCells[1],
              },
              {
                label: t("offerCargo.highwaySection"),
                cargo: highwaySectionCells[0],
                proposal: highwaySectionCells[1],
              },
              {
                label: t("offerCargo.fuelSurcharge"),
                cargo: fuelSurchargeCells[0],
                proposal: fuelSurchargeCells[1],
              },
              {
                label: t("offerCargo.cargoHandlingFee"),
                cargo: cargoHandlingFeeCells[0],
                proposal: cargoHandlingFeeCells[1],
              },
              {
                label: t("offerCargo.othersFee"),
                cargo: othersFeeCells[0],
                proposal: othersFeeCells[1],
              },
              {
                label: t("offerCargo.adjustmentFee"),
                cargo: adjustmentFeeCells[0],
                proposal: adjustmentFeeCells[1],
              },
              {
                label: t("offerCargo.paymentDate"),
                cargo: paymentDateCells[0],
                proposal: paymentDateCells[1],
              },
              {
                label: t("offerCargo.basicFeeMemo"),
                cargo: basicFeeMemoCells[0],
                proposal: basicFeeMemoCells[1],
              },
            ]}
          />
        </Box>
      </div>
    </DeliveryProposalFormLayout>
  );
};
